import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

/** Wraps a search-term-matched text fragment in dropdown option labels with a highlight background. */
export const StyledHighlightFragment = styled.span<{ $highlighted: boolean }>`
    ${({ $highlighted }) =>
        $highlighted &&
        css`
            background-color: ${colorsPalettes.blue[100]};
        `}
`;
